import uuid from 'uuid/v4';
import { isGdprCookiePermited } from 'helpers/gdprPreferences';
import { USER_SESSION_ID_NAME } from 'components/user/constants';
import { userDuck } from 'components/user/duck';
import { locationDuck } from 'components/location/duck';
import { manufacturersDuck } from 'store/ducks/manufacturers';

const TWO_YEARS_IN_DAYS = 730;

const generateTrackingId = () => uuid().replace(/-/g, '');

export const fetch = () =>
  function* ({ cookies, location }) {
    yield manufacturersDuck.tryLoad();

    let trackingId = cookies.get(USER_SESSION_ID_NAME);

    const isCookiePermitted = yield isGdprCookiePermited(
      cookies.getAll(),
      USER_SESSION_ID_NAME,
    );

    if (isCookiePermitted) {
      if (!trackingId) {
        trackingId = generateTrackingId();
        yield cookies.set(USER_SESSION_ID_NAME, trackingId, TWO_YEARS_IN_DAYS, {
          crossDomain: true,
          httpOnly: false,
        });
      }

      yield userDuck.set({
        trackingId,
      });

      yield locationDuck.set(location);
    }
  };
